import { createContext, useContext, useState, useCallback, useEffect, useRef } from "react";
import { Toaster, toast } from "sonner";

export const LANGS = [
  { code: "en", name: "English" },
  { code: "hi", name: "हिंदी" },
  { code: "mr", name: "मराठी" },
  { code: "gu", name: "ગુજરાતી" },
  { code: "ta", name: "தமிழ்" },
  { code: "te", name: "తెలుగు" },
  { code: "kn", name: "ಕನ್ನಡ" },
  { code: "bn", name: "বাংলা" },
  { code: "pa", name: "ਪੰਜਾਬੀ" },
  { code: "ml", name: "മലയാളം" },
];

const T = {
  en: {
    online: "online", typing: "typing...", recording: "recording...",
    msgPlaceholder: "Message likho...", recPlaceholder: "Bol rahe ho... 🎙️",
    freeLeft: "{n} free left",
    paywallTitle: "Free uses khatam! 😊",
    paywallSub: "Unlimited ke liye {plan} lo — sirf {price}",
    upgradeUpi: "UPI se Upgrade — {price}", upgradeCard: "Ya card se pay karo (Stripe)",
    inviteFree: "Ya dost ko invite karo — dono ko +1 free use",
    pricing: "Pricing", tryFree: "Try Free",
  },
  hi: {
    online: "ऑनलाइन", typing: "लिख रहे हैं...", recording: "रिकॉर्डिंग...",
    msgPlaceholder: "संदेश लिखें...", recPlaceholder: "बोलिए... 🎙️",
    freeLeft: "{n} फ्री बचे",
    paywallTitle: "फ्री उपयोग खत्म! 😊",
    paywallSub: "अनलिमिटेड के लिए {plan} लें — सिर्फ {price}",
    upgradeUpi: "UPI से अपग्रेड — {price}", upgradeCard: "या कार्ड से भुगतान करें (Stripe)",
    inviteFree: "या दोस्त को बुलाएं — दोनों को +1 फ्री उपयोग",
    pricing: "कीमत", tryFree: "फ्री आज़माएं",
  },
  mr: {
    online: "ऑनलाइन", typing: "लिहित आहे...", recording: "रेकॉर्डिंग...",
    msgPlaceholder: "संदेश लिहा...", recPlaceholder: "बोला... 🎙️",
    freeLeft: "{n} मोफत शिल्लक",
    paywallTitle: "मोफत वापर संपला! 😊",
    paywallSub: "अमर्यादित साठी {plan} घ्या — फक्त {price}",
    upgradeUpi: "UPI ने अपग्रेड — {price}", upgradeCard: "किंवा कार्डने पैसे द्या (Stripe)",
    inviteFree: "किंवा मित्राला बोलवा — दोघांना +1 मोफत वापर",
    pricing: "किंमत", tryFree: "मोफत वापरा",
  },
  gu: {
    online: "ઓનલાઇન", typing: "લખી રહ્યા છે...", recording: "રેકોર્ડિંગ...",
    msgPlaceholder: "સંદેશ લખો...", recPlaceholder: "બોલો... 🎙️",
    freeLeft: "{n} ફ્રી બાકી",
    paywallTitle: "ફ્રી ઉપયોગ પૂરો! 😊",
    paywallSub: "અમર્યાદિત માટે {plan} લો — માત્ર {price}",
    upgradeUpi: "UPI થી અપગ્રેડ — {price}", upgradeCard: "અથવા કાર્ડથી ચૂકવો (Stripe)",
    inviteFree: "અથવા મિત્રને બોલાવો — બંનેને +1 ફ્રી ઉપયોગ",
    pricing: "કિંમત", tryFree: "ફ્રી અજમાવો",
  },
  ta: {
    online: "ஆன்லைன்", typing: "தட்டச்சு...", recording: "பதிவு...",
    msgPlaceholder: "செய்தி எழுதுங்கள்...", recPlaceholder: "பேசுங்கள்... 🎙️",
    freeLeft: "{n} இலவசம் மீதம்",
    paywallTitle: "இலவச பயன்பாடு முடிந்தது! 😊",
    paywallSub: "வரம்பற்ற பயன்பாட்டிற்கு {plan} — வெறும் {price}",
    upgradeUpi: "UPI மூலம் மேம்படுத்து — {price}", upgradeCard: "அல்லது கார்டில் செலுத்துங்கள் (Stripe)",
    inviteFree: "அல்லது நண்பரை அழையுங்கள் — இருவருக்கும் +1 இலவசம்",
    pricing: "விலை", tryFree: "இலவசமாக முயற்சிக்கவும்",
  },
  te: {
    online: "ఆన్‌లైన్", typing: "టైప్ చేస్తోంది...", recording: "రికార్డింగ్...",
    msgPlaceholder: "సందేశం రాయండి...", recPlaceholder: "మాట్లాడండి... 🎙️",
    freeLeft: "{n} ఉచితం మిగిలింది",
    paywallTitle: "ఉచిత వినియోగం అయిపోయింది! 😊",
    paywallSub: "అపరిమితం కోసం {plan} — కేవలం {price}",
    upgradeUpi: "UPI తో అప్‌గ్రేడ్ — {price}", upgradeCard: "లేదా కార్డుతో చెల్లించండి (Stripe)",
    inviteFree: "లేదా స్నేహితుడిని పిలవండి — ఇద్దరికీ +1 ఉచితం",
    pricing: "ధర", tryFree: "ఉచితంగా ప్రయత్నించండి",
  },
  kn: {
    online: "ಆನ್‌ಲೈನ್", typing: "ಟೈಪ್ ಮಾಡುತ್ತಿದೆ...", recording: "ರೆಕಾರ್ಡಿಂಗ್...",
    msgPlaceholder: "ಸಂದೇಶ ಬರೆಯಿರಿ...", recPlaceholder: "ಮಾತನಾಡಿ... 🎙️",
    freeLeft: "{n} ಉಚಿತ ಉಳಿದಿದೆ",
    paywallTitle: "ಉಚಿತ ಬಳಕೆ ಮುಗಿಯಿತು! 😊",
    paywallSub: "ಅನಿಯಮಿತಕ್ಕಾಗಿ {plan} — ಕೇವಲ {price}",
    upgradeUpi: "UPI ಮೂಲಕ ಅಪ್‌ಗ್ರೇಡ್ — {price}", upgradeCard: "ಅಥವಾ ಕಾರ್ಡ್‌ನಿಂದ ಪಾವತಿಸಿ (Stripe)",
    inviteFree: "ಅಥವಾ ಸ್ನೇಹಿತರನ್ನು ಕರೆಯಿರಿ — ಇಬ್ಬರಿಗೂ +1 ಉಚಿತ",
    pricing: "ಬೆಲೆ", tryFree: "ಉಚಿತವಾಗಿ ಪ್ರಯತ್ನಿಸಿ",
  },
  bn: {
    online: "অনলাইন", typing: "টাইপ করছে...", recording: "রেকর্ডিং...",
    msgPlaceholder: "বার্তা লিখুন...", recPlaceholder: "বলুন... 🎙️",
    freeLeft: "{n}টি ফ্রি বাকি",
    paywallTitle: "ফ্রি ব্যবহার শেষ! 😊",
    paywallSub: "আনলিমিটেডের জন্য {plan} নিন — মাত্র {price}",
    upgradeUpi: "UPI দিয়ে আপগ্রেড — {price}", upgradeCard: "অথবা কার্ডে পেমেন্ট করুন (Stripe)",
    inviteFree: "অথবা বন্ধুকে ডাকুন — দুজনেই +1 ফ্রি ব্যবহার",
    pricing: "মূল্য", tryFree: "ফ্রি চেষ্টা করুন",
  },
  pa: {
    online: "ਆਨਲਾਈਨ", typing: "ਲਿਖ ਰਹੇ ਹਨ...", recording: "ਰਿਕਾਰਡਿੰਗ...",
    msgPlaceholder: "ਸੁਨੇਹਾ ਲਿਖੋ...", recPlaceholder: "ਬੋਲੋ... 🎙️",
    freeLeft: "{n} ਮੁਫ਼ਤ ਬਾਕੀ",
    paywallTitle: "ਮੁਫ਼ਤ ਵਰਤੋਂ ਖ਼ਤਮ! 😊",
    paywallSub: "ਅਣਲਿਮਿਟਡ ਲਈ {plan} ਲਓ — ਸਿਰਫ਼ {price}",
    upgradeUpi: "UPI ਨਾਲ ਅੱਪਗ੍ਰੇਡ — {price}", upgradeCard: "ਜਾਂ ਕਾਰਡ ਨਾਲ ਭੁਗਤਾਨ ਕਰੋ (Stripe)",
    inviteFree: "ਜਾਂ ਦੋਸਤ ਨੂੰ ਬੁਲਾਓ — ਦੋਵਾਂ ਨੂੰ +1 ਮੁਫ਼ਤ ਵਰਤੋਂ",
    pricing: "ਕੀਮਤ", tryFree: "ਮੁਫ਼ਤ ਅਜ਼ਮਾਓ",
  },
  ml: {
    online: "ഓൺലൈൻ", typing: "ടൈപ്പ് ചെയ്യുന്നു...", recording: "റെക്കോർഡിംഗ്...",
    msgPlaceholder: "സന്ദേശം എഴുതൂ...", recPlaceholder: "സംസാരിക്കൂ... 🎙️",
    freeLeft: "{n} സൗജന്യം ബാക്കി",
    paywallTitle: "സൗജന്യ ഉപയോഗം തീർന്നു! 😊",
    paywallSub: "അൺലിമിറ്റഡിനായി {plan} — വെറും {price}",
    upgradeUpi: "UPI വഴി അപ്‌ഗ്രേഡ് — {price}", upgradeCard: "അല്ലെങ്കിൽ കാർഡിൽ പണമടയ്ക്കൂ (Stripe)",
    inviteFree: "അല്ലെങ്കിൽ സുഹൃത്തിനെ ക്ഷണിക്കൂ — രണ്ടുപേർക്കും +1 സൗജന്യം",
    pricing: "വില", tryFree: "സൗജന്യമായി ശ്രമിക്കൂ",
  },
};

const AUTO_NOTICE = {
  hi: "भाषा हिंदी में बदल दी गई — ऊपर मेनू से कभी भी बदलें",
  mr: "भाषा मराठीत बदलली — वरच्या मेनूमधून कधीही बदला",
  gu: "ભાષા ગુજરાતીમાં બદલાઈ — ઉપરના મેનૂમાંથી ગમે ત્યારે બદલો",
  ta: "மொழி தமிழாக மாற்றப்பட்டது — மேலே உள்ள மெனுவில் எப்போதும் மாற்றலாம்",
  te: "భాష తెలుగులోకి మార్చబడింది — పైన మెనూ నుండి ఎప్పుడైనా మార్చండి",
  kn: "ಭಾಷೆ ಕನ್ನಡಕ್ಕೆ ಬದಲಾಯಿಸಲಾಗಿದೆ — ಮೇಲಿನ ಮೆನುವಿನಿಂದ ಯಾವಾಗ ಬೇಕಾದರೂ ಬದಲಿಸಿ",
  bn: "ভাষা বাংলায় পরিবর্তন করা হয়েছে — উপরের মেনু থেকে যেকোনো সময় বদলান",
  pa: "ਭਾਸ਼ਾ ਪੰਜਾਬੀ ਵਿੱਚ ਬਦਲ ਦਿੱਤੀ ਗਈ — ਉੱਪਰਲੇ ਮੇਨੂ ਤੋਂ ਕਦੇ ਵੀ ਬਦਲੋ",
  ml: "ഭാഷ മലയാളത്തിലേക്ക് മാറ്റി — മുകളിലെ മെനുവിൽ നിന്ന് എപ്പോൾ വേണമെങ്കിലും മാറ്റാം",
};

function detectBrowserLang() {
  const codes = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || "en"];
  for (const c of codes) {
    const base = (c || "").toLowerCase().split("-")[0];
    if (T[base]) return base;
  }
  return "en";
}

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const autoDetected = useRef(null);
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("kash_lang");
    if (saved) return saved;
    const detected = detectBrowserLang();
    localStorage.setItem("kash_lang", detected);
    if (detected !== "en") autoDetected.current = detected;
    return detected;
  });
  const setLang = useCallback((code) => {
    localStorage.setItem("kash_lang", code);
    setLangState(code);
  }, []);
  useEffect(() => {
    if (!autoDetected.current) return;
    const code = autoDetected.current;
    autoDetected.current = null;
    const name = (LANGS.find((l) => l.code === code) || {}).name || code;
    setTimeout(() => {
      toast(AUTO_NOTICE[code] || `Language set to ${name}`, {
        duration: 8000,
        action: { label: "English", onClick: () => setLang("en") },
      });
    }, 800);
  }, [setLang]);
  const t = useCallback((key, vars = {}) => {
    let s = (T[lang] && T[lang][key]) || T.en[key] || key;
    Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
    return s;
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
      <Toaster position="top-center" richColors data-testid="lang-toast" />
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
export const getLang = () => localStorage.getItem("kash_lang") || "en";
